// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { Resources } from '@shared/localizations/Resources';
import { TimeZoneInfo } from '@shared/utils/Time/TimeZoneInfo';
import { TimeZoneInfoSet } from '@shared/utils/Time/TimeZoneInfoSet';
import TerceraTimeZoneSelectorTemplate from '@front/templates/TerceraTimeZoneSelectorTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { PropertySetupScreen } from '../screen/PropertySetupScreen';
import { Control } from './Control';
import { DynProperty } from '@shared/commons/DynProperty';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { DateTimeConvertor } from '@shared/utils/Time/DateTimeConvertor';
import $ from 'jquery';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraTimeZoneSelector extends Control {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraTimeZoneSelector;
    }
    oninit() {
        super.oninit();
        Control.Ticker.Subscribe(this.updateTime, this);
    }
    showMenu() {
        const offset = $(this.find('*')).offset();
        const posY = offset.top - $(window).scrollTop();
        const posX = offset.left - $(window).scrollLeft();
        const items = this.getMenuItems();
        showContextMenu({ x: posX, y: posY, items: items });
    }
    getMenuItems() {
        const resourceKeyPrefix = 'screen.TimeZoneSelector.';
        const items = [
            {
                type: NewContextMenuItemType.Default,
                text: Resources.getResource(resourceKeyPrefix + 'TIMEZONE_LOCAL'),
                tag: TimeZoneInfo.LOCAL,
                event: (item) => {
                    TerceraTimeZoneSelector.updateCurrentTimeZone(item);
                }
            },
            {
                type: NewContextMenuItemType.Default,
                text: Resources.getResource(resourceKeyPrefix + 'TIMEZONE_SERVER'),
                tag: TimeZoneInfo.SERVER,
                event: (item) => {
                    TerceraTimeZoneSelector.updateCurrentTimeZone(item);
                }
            }
        ];
        items.push.apply(items, this.getFavoriteTimeZoneMenuItems());
        items.push({
            type: NewContextMenuItemType.Default,
            text: Resources.getResource(resourceKeyPrefix + 'Customize'),
            event: this.showCustomizeScreen.bind(this)
        });
        return items;
    }
    getFavoriteTimeZoneMenuItems() {
        const favoriteTZIArray = [];
        for (const key in SessionSettings.favoriteTimeZoneInfoIdsSet) {
            favoriteTZIArray.push(TimeZoneInfoSet[key]);
        }
        favoriteTZIArray.sort(TimeZoneInfo.compare);
        const menuItems = [];
        for (let i = 0, len = favoriteTZIArray.length; i < len; i++) {
            const tzi = favoriteTZIArray[i];
            menuItems.push({
                type: NewContextMenuItemType.Default,
                text: tzi.toLocalizedString(),
                tag: tzi.id,
                event: (item) => {
                    TerceraTimeZoneSelector.updateCurrentTimeZone(item);
                }
            });
        }
        return menuItems;
    }
    showCustomizeScreen() {
        void PropertySetupScreen.editProperty(this, 'screen.TimeZoneSelector.title');
    }
    updateTime() {
        const currentTZInfoId = DateTimeConvertor.currentTimeZoneInfoId.value;
        const tzInfo = TimeZoneInfoSet[currentTZInfoId];
        if (isNullOrUndefined(tzInfo))
            return;
        const now = DateTimeUtils.DateTimeUtcNow();
        const userUtcOffset = tzInfo.baseUtcOffset;
        const utcOffsetDeltaMillis = (userUtcOffset.totalMinutes() + now.getTimezoneOffset()) * 60 * 1000;
        now.setTime(now.getTime() + utcOffsetDeltaMillis);
        const utcOffsetString = userUtcOffset.toString();
        const utcString = isValidString(utcOffsetString) ? ' (UTC' + utcOffsetString + ')' : ' (UTC)';
        void this.set('currentTime', DateTimeUtils.formatDate(now, 'HH:mm:ss') + utcString);
    }
    // #region ICaller
    Properties() {
        const sess = SessionSettings;
        const curTZInfoId = DateTimeConvertor.currentTimeZoneInfoId.value;
        const favTZInfoIdsSet = sess.favoriteTimeZoneInfoIdsSet;
        const props = [];
        const tzInfoSet = TimeZoneInfoSet;
        for (const key in tzInfoSet) {
            const tzInfo = tzInfoSet[key];
            if (tzInfo.id === TimeZoneInfo.LOCAL || tzInfo.id === TimeZoneInfo.SERVER) {
                continue;
            }
            const isFavTZ = favTZInfoIdsSet.hasOwnProperty(tzInfo.id);
            const dp = new DynProperty(tzInfo.id, isFavTZ, DynProperty.BOOLEAN, DynProperty.VIEW_GROUP);
            dp.localizationKey = tzInfo.toLocalizedString();
            dp.enabled = curTZInfoId !== tzInfo.id;
            dp.sortIndex = tzInfo.sortIndex;
            props.push(dp);
        }
        return props;
    }
    callBack(props) {
        const favIdsSet = {};
        const len = props.length;
        for (let i = 0; i < len; i++) {
            const dp = props[i];
            if (dp.value) {
                favIdsSet[dp.name] = true;
            }
        }
        SessionSettings.updateFavoriteTimeZoneInfoIdsSet(favIdsSet);
    }
    // #endregion
    static updateCurrentTimeZone(menuItem) {
        SessionSettings.updateCurrentTimeZoneInfoId(menuItem.tag);
    }
}
Control.extendWith(TerceraTimeZoneSelector, {
    template: TerceraTimeZoneSelectorTemplate,
    data: function () {
        return { currentTime: '' };
    }
});
